import { useQuery } from '@tanstack/react-query';
import { Building2, Package, Scale, DollarSign } from 'lucide-react';
import { inventoryApi } from '../../lib/api';
import PageHeader from '../../components/PageHeader';

export default function InventoryByStorage() {
  const { data, isLoading } = useQuery({
    queryKey: ['inventory', 'by-storage'],
    queryFn: () => inventoryApi.getByStorage(),
  });

  const formatNumber = (num: any) => {
    if (num === null || num === undefined) return '0';
    return Number(num).toLocaleString('ja-JP');
  };

  return (
    <div className="animate-fadeIn">
      <PageHeader
        title="倉庫別在庫一覧"
        description="冷蔵庫ごとの在庫状況"
        breadcrumbs={[
          { label: '在庫管理' },
          { label: '倉庫別在庫' },
        ]}
      />

      {isLoading ? (
        <div className="flex items-center justify-center py-12">
          <div className="w-8 h-8 border-2 border-t-transparent rounded-full animate-spin"
            style={{ borderColor: 'var(--accent-color)', borderTopColor: 'transparent' }}
          />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {data?.data?.data?.map((storage: any) => (
            <div key={storage.coldStorage.id} className="card hover:shadow-lg transition-shadow cursor-pointer">
              <div className="flex items-start gap-4 mb-4">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: 'var(--accent-color)' }}
                >
                  <Building2 size={24} className="text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg" style={{ color: 'var(--text-primary)' }}>
                    {storage.coldStorage.name}
                  </h3>
                  <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
                    {storage.coldStorage.storageCategory === 'chilled' ? 'チルド' :
                     storage.coldStorage.storageCategory === 'frozen' ? '冷凍' : '両用'}
                  </p>
                </div>
              </div>

              <div className="space-y-3">
                <div className="flex items-center justify-between p-3 rounded-lg" style={{ backgroundColor: 'var(--light-gray-tertiary)' }}>
                  <div className="flex items-center gap-2">
                    <Package size={16} style={{ color: 'var(--text-secondary)' }} />
                    <span className="text-sm" style={{ color: 'var(--text-secondary)' }}>在庫数</span>
                  </div>
                  <span className="font-semibold" style={{ color: 'var(--text-primary)' }}>
                    {formatNumber(storage.totalQuantity)} ケース
                  </span>
                </div>

                <div className="flex items-center justify-between p-3 rounded-lg" style={{ backgroundColor: 'var(--light-gray-tertiary)' }}>
                  <div className="flex items-center gap-2">
                    <Scale size={16} style={{ color: 'var(--text-secondary)' }} />
                    <span className="text-sm" style={{ color: 'var(--text-secondary)' }}>総重量</span>
                  </div>
                  <span className="font-semibold" style={{ color: 'var(--text-primary)' }}>
                    {formatNumber(storage.totalWeight)} kg
                  </span>
                </div>

                <div className="flex items-center justify-between p-3 rounded-lg" style={{ backgroundColor: 'var(--light-gray-tertiary)' }}>
                  <div className="flex items-center gap-2">
                    <DollarSign size={16} style={{ color: 'var(--text-secondary)' }} />
                    <span className="text-sm" style={{ color: 'var(--text-secondary)' }}>在庫金額</span>
                  </div>
                  <span className="font-semibold" style={{ color: 'var(--text-primary)' }}>
                    ¥{formatNumber(storage.totalValue)}
                  </span>
                </div>
              </div>

              <div className="mt-4 pt-4 border-t" style={{ borderColor: 'var(--border-color)' }}>
                <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
                  在庫件数: {formatNumber(storage.itemCount)} 件
                </p>
              </div>
            </div>
          )) || (
            <div className="col-span-full text-center py-12" style={{ color: 'var(--text-secondary)' }}>
              倉庫別在庫データがありません
            </div>
          )}
        </div>
      )}
    </div>
  );
}


